import React, { forwardRef, useState, useEffect } from "react";
import "../css/style.css";
import "../css/responsive.css";
import "../css/bootstrap.min.css";
import InvestmentHeader from './investment-activity-report-header';
import InvestmentContent from './investment-activity-report-content';
import InvestmentTable from './investment-activity-report-table'; // Uncomment if needed
import callingAPI from "../service"
import { setDashboardData } from "../redux/reducers/dashboardSlice";
import loadingImage from '../images/login-shape.png'
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

const InvestmentAccountActivityReportPdf = forwardRef((props, ref) => {
    const dashboardDetails = useSelector((state) => state.Dashboard);
    const reportDetails = useSelector((state) => state.report.cashsummary);
    const formatDate = (date) => {
        return new Date(date).toISOString().split('T')[0];
    };
    const [cashStatementSummery, setCashStatementSummery] = useState([])
    const [clientAddressDetails, setClientAddressDetails] = useState({
        building: "48 Burj Gate",
        street: "Sheikh Zayed Road",
        citya: "Dubai",
        countrya: "United Arab Emirates",
        officeno: "801",
        trnno: "",
        mobile: "919961727479",
        postbox: "119930"
    });
    const [cashStatementDetails, setCashStatementDetails] = useState([])
    const [cashStatementSummeryTotal, setCashStatementSummeryTotal] = useState([])
    const refreshToken = dashboardDetails.refreshToken;
    const [formattedFromDate, setFormattedFromDate] = useState(() =>
        props.fromDate ? formatDate(props.fromDate) : formatDate(new Date())
    );
    const [formattedToDate, setFormattedToDate] = useState(() =>
        props.toDate ? formatDate(props.toDate) : formatDate(new Date())
    );

    const containerStyle = {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '21cm',
        width: '100%',
        margin: '0 auto',
        padding: '0 15px 0 15px',
        position: 'relative',
        fontFamily: 'Roboto Medium',
        color: '#000',
        fontSize: '13px',
        boxSizing: 'border-box'
    };

    const htmlBodyStyle = {
        width: '100%',
        margin: '0',
        padding: '0',
        overflowX: 'hidden'
    };

    const headerStyle = {
        // marginBottom: '1cm',
    };

    const mainStyle = {
        flex: '1',
        marginBottom: '1cm',
    };

    const footerStyle = {
        width: '100%',
        boxSizing: 'border-box',
        borderTop: '2px solid #d5d5d5',
        textAlign: 'center',
        fontSize: '12px',
        padding: '5px',
        position: 'absolute',
        bottom: '-10px',
    };

    useEffect(() => {


        console.log("props....", props, ref);
        if (props.fromDate != undefined && props.toDate != undefined) {
            const formattedFromDates = formatDate(props.fromDate);
            const formattedToDates = formatDate(props.toDate);
            setFormattedFromDate(formattedFromDates)
            setFormattedToDate(formattedToDates)
        } else {
            setFormattedFromDate(formatDate(new Date()))
            setFormattedToDate(formatDate(new Date()))
        }
    }, [props.fromDate, props.toDate]);

    useEffect(() => {
        // cashSummaryReportList();
        setCashStatementSummery(reportDetails?.cashStatementSummery?.data || []);
        setClientAddressDetails(reportDetails?.clientAddressDetails || clientAddressDetails);
        setCashStatementSummeryTotal(reportDetails?.cashStatementSummery?.total || []);
        setCashStatementDetails(reportDetails?.cashStatementDetails || []);
        document.documentElement.style.cssText = `width: 100%; margin: 0; padding: 0; overflow-x: hidden;`;
        document.body.style.cssText = `width: 100%; margin: 0; padding: 0; overflow-x: hidden;`;
    }, [reportDetails]);

    const cashSummaryReportList = () => {
        const clientId = dashboardDetails.clientid;
        const userId = dashboardDetails.userId
        const postData = {
            "userId": userId,
            "fromDate": props.fromDate != undefined ? formatDate(props.fromDate) : formatDate(new Date()),
            "toDate": props.toDate != undefined ? formatDate(props.toDate) : formatDate(new Date()),
            "clientId": clientId,
            //"refreshToken": refreshToken
        }
        callingAPI(postData, "reports/cashReport", 'post')
            .then((response) => {
                const { data } = response;
                if (data.statusCode === 200) {
                    setCashStatementSummery(data.data.cashStatementSummery.data || []);
                    setClientAddressDetails(data.data?.clientAddressDetails || clientAddressDetails);
                    setCashStatementSummeryTotal(data.data.cashStatementSummery.total || []);
                    setCashStatementDetails(data.data.cashStatementDetails || []);
                } else {
                    console.error('Failed to fetch profile details:', data.message);
                }
            })
            .catch((error) => {
                console.error('Error during profile fetch:', error);
            });
    };
    // const totalAEDBalance = (cashStatementSummeryTotal || []).reduce((total, item) => total + parseFloat(item?.total), 0);
    const totalAEDBalance = parseFloat(cashStatementSummeryTotal);

    return (
        <div ref={ref} id="pdf-content">
            <div style={containerStyle} ref={ref} id="pdf-content">
                <header style={headerStyle}>
                    <InvestmentHeader clientAddressDetails={clientAddressDetails} fromDate={formattedFromDate}
                        toDate={formattedToDate} />
                </header>
                <hr />
                <main style={mainStyle}>
                    <InvestmentContent cashStatementSummery={cashStatementSummery} totalAEDBalance={totalAEDBalance} />

                </main>
                <footer style={footerStyle}>
                    <div style={{ lineHeight: "15px" }}>
                        <div>A Subsidiary of DUBAI INVESTMENTS</div>
                        <div>
                            {clientAddressDetails.building}, {clientAddressDetails.street}, {clientAddressDetails.citya}, {clientAddressDetails.countrya}.
                            Office {clientAddressDetails.officeno}, P.O. Box-{clientAddressDetails.postbox}, Tel: {clientAddressDetails.mobile},
                        </div>
                        <div>Al Mal Capital PSC is Registered with Federal Tax Authority with VAT Number {clientAddressDetails.trnno}</div>
                    </div>
                    <div className="pb-2 pt-3" style={{ lineHeight: "15px" }}>
                        <div>Al Mal Capital PSC is incorporated in Dubai UAE under CR 76761 as a Private Joint Stock Company with a paid-up share capital of AED 219.78 Million</div>
                        <div>(Al Mal Capital PSC is licensed and regulated by the Securities and Commodities Authorities, License No# 603022)</div>
                    </div>
                </footer>
            </div>
            <div style={containerStyle} >
                <div style={mainStyle}>
                    <InvestmentTable cashStatementDetails={cashStatementDetails} clientAddressDetails={clientAddressDetails} fromDate={formattedFromDate}
                        toDate={formattedToDate} />
                </div>

            </div>
        </div>

    );
});

export default InvestmentAccountActivityReportPdf;

